import { DefaultState } from 'store/types';

export const GET_GUESTS_REQUEST = 'GET_GUESTS_REQUEST';
export const GET_GUESTS_SUCCESS = 'GET_GUESTS_SUCCESS';
export const GET_GUESTS_FAILURE = 'GET_GUESTS_FAILURE';

export interface GetGuestsParams {
  filters: GetGuestsFilters;
  paging: {
    page: number;
    pageSize: number;
  };
  sorting: {
    id: string;
    order: string;
  };
}

export interface GetGuestsFilters {
  guestName?: string | null;
  guestId?: string | null;
  gender?: string | null;
  guestType?: string | null;
  dates?: string | null;
  fromDate?: string | null;
  toDate?: string | null;
}

export interface GetGuestRow {
  id: string;
  domainId: string;
  guestType: string;
  firstName: string;
  lastName: string;
  gender: string;
  all: number;
  open: number;
  pending: number;
  draft: number;
  completed: number;
  canceled: number;
  lastRequestDate?: string;
}

export interface GetGuestsData {
  rows: GetGuestRow[];
  totalCount: number;
}

export type GetGuestsState = DefaultState & {
  contents?: GetGuestsData;
};

interface GetGuestsRequest {
  type: typeof GET_GUESTS_REQUEST;
}

interface GetGuestsSuccess {
  type: typeof GET_GUESTS_SUCCESS;
  contents: GetGuestsData;
}

interface GetGuestsFailure {
  type: typeof GET_GUESTS_FAILURE;
}

export type GetGuestsActionTypes = GetGuestsRequest | GetGuestsSuccess | GetGuestsFailure;
